module.exports = __webpack_public_path__ + "img/nav-icon.597a9aed.svg";